module.exports = __webpack_public_path__ + "img/icon_validate_white.9e84e8cc.svg";